import { createSlice, createSelector } from '@reduxjs/toolkit';
import {
    getAllCampaigns,
    getCampaignDetails,
    createCampaign,
    deleteCampaign,
    deleteCampaigns,
    deleteImage,
    uploadImage,
    getCampaignTriggers,
    getSelectedCampaignPartners,
    getSelectedCampaignChannels,
    getCampaignIngestion,
    updateCampaignGeneration,
    updateCampaign,
    updateCampaigningestion,
} from '../thunks/campaignThunks';
import { toast } from "react-toastify";

const campaign = createSlice({
    name: 'campaign',
    initialState: {
        campaign: {
            id: null,
            name: null,
            type: null,
            partner_id: null,
            partner_connection_id: null,
            partner: null,
            message: null,
            schedule: 'Monday',
            hour: 0,
            auto_scheduler: false,
            triggers: [],
            summary: [],
            images: [],
        },
        isCampaignDataLoading: false,
        isCampaignCreated: false,
        isCampaignUpdated: false,
        campaignTypes: [],
        selectedCampaignTypes: [],
        campaigns: [],
        physicianCounts: {},
        targetListImportance: {},
        intensity: {},
        isLoading: false,
        isImageLoading: false,
        campaignsummary: null,
        triggers: [],
        channels: [],
        partners: [],
        campaignGenerationType: 'MANUAL',
        selectedIngestion: 0,
        selectAllCampaigns: false,
        selectedRows: [],
    },
    reducers: {
        selectCampaignRows: (state, action) => {
            state.selectedRows = action.payload.rows;
        },
        setAllCampaigns: (state, action) => {
            state.selectAllCampaigns = action.payload.isSelected;
        },
        resetCampaignState: (state, action) => {
            state.campaign = {
              id: null,
              name: null,
              type: null,
              partner_id: null,
              partner_connection_id: null,
              partner: null,
              message: null,
              schedule: 'Monday',
              hour: 0,
              auto_scheduler: false,
              triggers: [],
              summary: [],
              images: [],
            };
            state.isCampaignCreated = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCampaigns.fulfilled, (state, action) => {
                state.isLoading = false;
                state.campaigns = action.payload.campaigns;
            })
            .addCase(getAllCampaigns.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAllCampaigns.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(getCampaignDetails.fulfilled, (state, action) => {
                state.isCampaignDataLoading = false;
                state.campaign = action.payload.campaign;
                state.isCampaignCreated = true;
            })
            .addCase(getCampaignDetails.pending, (state, action) => {
                state.isCampaignDataLoading = true;
            })
            .addCase(getCampaignDetails.rejected, (state, action) => {
                state.isCampaignDataLoading = false;
                state.error = action.payload;
            })
            .addCase(createCampaign.fulfilled, (state, action) => {
                state.isCampaignDataLoading = false;
                if(action.payload.status_code === 200){
                    state.campaign = action.payload.campaign;
                    state.isCampaignCreated = true;
                    toast.success(action.payload.success);
                } else {
                    toast.error(action.payload.error.name);
                }
            })
            .addCase(createCampaign.pending, (state, action) => {
                state.isCampaignDataLoading = true;
            })
            .addCase(createCampaign.rejected, (state, action) => {
                state.isCampaignDataLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getCampaignTriggers.fulfilled, (state, action) => {
                state.isCampaignDataLoading = false;
                state.triggers = action.payload.triggers;
            })
            .addCase(getCampaignTriggers.pending, (state, action) => {
                state.isCampaignDataLoading = true;
            })
            .addCase(getCampaignTriggers.rejected, (state, action) => {
                state.isCampaignDataLoading = false;
                state.error = action.payload;
            })
            .addCase(getSelectedCampaignPartners.fulfilled, (state, action) => {
                state.isCampaignDataLoading = false;
                state.partners = action.payload.partners;
            })
            .addCase(getSelectedCampaignPartners.pending, (state, action) => {
                state.isCampaignDataLoading = true;
            })
            .addCase(getSelectedCampaignPartners.rejected, (state, action) => {
                state.isCampaignDataLoading = false;
                state.error = action.payload;
            })
            .addCase(getSelectedCampaignChannels.fulfilled, (state, action) => {
                state.isCampaignDataLoading = false;
                state.channels = action.payload.channels;
            })
            .addCase(getSelectedCampaignChannels.pending, (state, action) => {
                state.isCampaignDataLoading = true;
            })
            .addCase(getSelectedCampaignChannels.rejected, (state, action) => {
                state.isCampaignDataLoading = false;
                state.error = action.payload;
            })
            .addCase(getCampaignIngestion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.campaignGenerationType = action.payload?.campaign?.campaign_generate_type || 'MANUAL' ;
                state.selectedIngestion = action.payload?.result[0]?.selected || 0;
            })
            .addCase(getCampaignIngestion.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getCampaignIngestion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(updateCampaignGeneration.fulfilled, (state,action) => {
                if(action.payload?.status_code === 200){
                    state.error = null;
                    state.isLoading = false;
                    state.campaignGenerationType = action.payload?.result?.campaign_generate_type
                    toast.success("Campaign Generation Type updated successfully.")
                }
                else{
                    state.isLoading = false;
                    toast.error("Please retry!")
                }
            })
            .addCase(updateCampaignGeneration.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateCampaignGeneration.rejected, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateCampaigningestion.fulfilled, (state, action) => {
                state.isLoading = false;
                if(action.payload?.status_code === 200){
                    state.selectedIngestion = action.payload?.result?.selected
                    toast.success("Ingestion Type updated successfully.")
                }
            })
            .addCase(updateCampaigningestion.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateCampaigningestion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteCampaign.fulfilled, (state, action) => {
                state.isLoading = false;
                toast.success(action.payload.success);
            })
            .addCase(deleteCampaign.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(deleteCampaign.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deleteCampaigns.fulfilled, (state, action) => {
                state.isLoading = false;
                toast.success(action.payload.success);
            })
            .addCase(deleteCampaigns.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(deleteCampaigns.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(updateCampaign.fulfilled, (state, action) => {
                state.isCampaignUpdated = false;
                if(action.payload?.status_code === 200){
                    state.connection = action.payload.connection;
                    toast.success(action.payload.success);
                } else {
                    toast.error(action.payload.error.name);
                }
            })
            .addCase(updateCampaign.pending, (state, action) => {
                state.isCampaignUpdated = true;
            })
            .addCase(updateCampaign.rejected, (state, action) => {
                state.isCampaignUpdated = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(uploadImage.fulfilled, (state, action) => {
                state.isImageLoading = false;
                if (action.payload.status_code === 200) {
                    toast.success(action.payload.success);
                    state.campaign.images.push(action.payload.image);
                } else {
                    toast.error(action.payload.error);
                }
            })
            .addCase(uploadImage.pending, (state, action) => {
                state.isImageLoading = true;
            })
            .addCase(uploadImage.rejected, (state, action) => {
                state.isImageLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deleteImage.fulfilled, (state, action) => {
                state.isImageLoading = false;
                if (action.payload.status_code === 200) {
                    toast.success(action.payload.success);
                } else {
                    toast.error(action.payload.error);
                }
            })
            .addCase(deleteImage.pending, (state, action) => {
                state.isImageLoading = true;
            })
            .addCase(deleteImage.rejected, (state, action) => {
                state.isImageLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
    },
});

const getCampaignTypeAvailableOptions = (state) => {    
    return state.campaign.campaignTypes.map(type => ({
      name: type.name,
      id: type.id,
      label: type.name,
      value: type.id,
    }));
};

const getCampaignTypeSelectedOptions = (state) => {
    return state.campaign.selectedCampaignTypes.map(type => ({
      name: type.name,
      id: type.id,
      label: type.name,
      value: type.id,
    }));
};

const getTargetDurationOptions = (state) => {
    const targetDurationOptions = [];
    
    for (let i = 1; i <= 12; i++) {
      targetDurationOptions.push({
        name: i === 1 ? '1 Week' : `${i} Weeks`,
        id: i,
        label: i === 1 ? '1 Week' : `${i} Weeks`,
        value: i,
      });
    } 
    
    return targetDurationOptions;
};

const getEstimatedDurationOptions = (state) => {
        const t_duration = [];
        t_duration.push({
            name: '1 Month',
            id: 1,
            label: '1 Month',
            value: 1
        });

        for (var i = 2; i <= 12; i++) {
            t_duration.push({
                name: i + ' Months',
                id: i,
                label: i + ' Months',
                value: i
            });
        }

        return t_duration;
};

const getSelectedTargetDurationByValue = (state, val) => {
    const foundItem = state.campaign.getTargetDurationSelectedOptions.find(
      ({ value }) => value === val
    );
    if (!foundItem) {
      console.warn(
        `current Target Duration id: ${val} but available ids: ${state.campaign.getTargetDurationSelectedOptions
          .map(({ value }) => value)
          .join(',')}`
      );
      return null;
    }
    console.log(`Target Duration: ${val} found`, foundItem);
    return foundItem;
};

export const selectCampaignPartnerOptions = () => createSelector(
    (state) => state.campaign,
    (campaign) => {
      let campaignPartners = campaign.partners?.map((partner) => {
        return {
            name: partner.name,
            id: partner.id,
            label: partner.name,
            value: partner.id,
        };
    });
  
      return campaignPartners;
    }
);

export const selectCampaignTriggerOptions = () => createSelector(
    (state) => state.campaign,
    (campaign) => {
      let campaignTriggers = campaign.triggers?.map((trigger) => {
        return {
            name: trigger.name,
            id: trigger.id,
            label: trigger.name,
            value: trigger.id,
        };
    });
  
      return campaignTriggers;
    }
);

export const selectCampaignChannelOptions = () => createSelector(
    (state) => state.campaign,
    (campaign) => {
      let campaignChannels = campaign.channels?.map((channel) => {
        return {
            name: channel.name,
            id: channel.id,
            label: channel.name,
            value: channel.id,
            templateId: channel.templateId,
        };
    })
  
      return campaignChannels;
    }
);

export {
    getTargetDurationOptions,
    getEstimatedDurationOptions,
    getCampaignTypeAvailableOptions,
    getCampaignTypeSelectedOptions,
    getSelectedTargetDurationByValue,
};
export const { actions } = campaign;

export default campaign.reducer;
